import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FiMenu, FiUser, FiLogOut, FiChevronDown } from "react-icons/fi";
import { selectUser } from "../../store/authSlice";
import styles from "./DashboardHeader.module.css";

const initials = (name = "") =>
  name
    .split(" ")
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase() || "A";

export default function DashboardHeader({ basePath = "admin", onLogout, onOpenSidebar, showMenu }) {
  const user = useSelector(selectUser);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const goProfile = () => {
    setOpen(false);
    navigate(`/${basePath}/profile`);
  };

  const handleLogout = () => {
    setOpen(false);
    onLogout?.();
  };

  return (
    <header className={styles.header}>
      {showMenu && (
        <button
          type="button"
          className={styles.menuBtn}
          onClick={onOpenSidebar}
          aria-label="Open menu"
        >
          <FiMenu size={20} />
        </button>
      )}

      <div className={styles.spacer} />

      <div className={styles.profile} ref={ref}>
        <button
          type="button"
          className={styles.profileBtn}
          onClick={() => setOpen((o) => !o)}
        >
          {user?.image ? (
            <img src={user.image} alt={user?.name || "Profile"} className={styles.avatar} />
          ) : (
            <span className={styles.avatarFallback}>{initials(user?.name)}</span>
          )}
          <FiChevronDown className={`${styles.chevron} ${open ? styles.chevronUp : ""}`} />
        </button>

        {open && (
          <div className={styles.dropdown}>
            <div className={styles.dropdownHeader}>
              <div className={styles.dropdownName}>{user?.name || "Admin"}</div>
              <div className={styles.dropdownRole}>{user?.role_name || ""}</div>
            </div>
            <button className={styles.dropdownItem} onClick={goProfile}>
              <FiUser /> Profile Setting
            </button>
            <button
              className={`${styles.dropdownItem} ${styles.logout}`}
              onClick={handleLogout}
            >
              <FiLogOut /> Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
